import styled from "styled-components";

export const StyledViewCountTooltip = styled.div`
  position: relative;
  display: inline-block;

  .viewCountTrigger {
    display: inline-block;
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    font: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    text-align: inherit;
    cursor: pointer;
  }

  .visuallyHidden {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .viewCountPopover {
    display: none;
    position: absolute;
    bottom: 100%;
    left: -10px;
    z-index: 5;
    /* 透明的下緣留白讓滑鼠從數字移到浮層時不會離開 hover 範圍，才點得到連結 */
    padding-bottom: 10px;
    cursor: default;

    &.isVisible {
      display: block;
    }
  }

  .popoverBody {
    width: max-content;
    max-width: 240px;
    padding: 8px 12px;
    background: #121212;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
    white-space: normal;
  }

  .popoverTitle {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #ffffff;
  }

  .popoverNote {
    color: #d9d9d9;
  }

  .popoverLink {
    display: inline-block;
    margin-top: 4px;
    color: #ff744e;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: #ffa270;
    }
  }

  .arrowDown {
    position: absolute;
    bottom: 2px;
    left: 15px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #121212;
  }
`;
